import axios from '@/utils/axios';
import urlConfig from '@/utils/urlConfig';

export default {
  // ========== 商户配置 ==========
  getMerchantConfigList: (data) => axios.apiPost(
    urlConfig.busiURL + '/tax/merchant/config/list', data
  ),
  getMerchantConfigDetail: (id) => axios.apiGet(
    urlConfig.busiURL + '/tax/merchant/config/detail?id=' + id
  ),
  addMerchantConfig: (data) => axios.apiPost(
    urlConfig.busiURL + '/tax/merchant/config/add', data
  ),
  updateMerchantConfig: (data) => axios.apiPost(
    urlConfig.busiURL + '/tax/merchant/config/update', data
  ),
  changeMerchantConfigStatus: (data) => axios.apiPost(
    urlConfig.busiURL + '/tax/merchant/config/status', data
  ),

  // ========== 商户统计流水 ==========
  getMerchantStatCockpit: (params) => axios.apiGet(
    urlConfig.busiURL + '/tax/merchant/stat/cockpit', params
  ),
  getMerchantStatCards: (data) => axios.apiPost(
    urlConfig.busiURL + '/tax/merchant/stat/cards', data
  ),
  getMerchantStatDetail: (params) => axios.apiGet(
    urlConfig.busiURL + '/tax/merchant/stat/merchant-detail', params
  ),
  getMerchantStatFlow: (data) => axios.apiPost(
    urlConfig.busiURL + '/tax/merchant/stat/flow', data
  ),

  // ========== 订单 ==========
  migratePayOrder: (payOrderSerialNo) => axios.apiPost(
    urlConfig.busiURL + '/tax/order/migrate/payorder?payOrderSerialNo=' + payOrderSerialNo
  ),
  batchMigratePayOrder: () => axios.apiPost(
    urlConfig.busiURL + '/tax/order/migrate/payorder/batch'
  ),
  getOrderList: (data) => axios.apiPost(
    urlConfig.busiURL + '/tax/order/list', data
  ),
  getOrderDetail: (orderNo) => axios.apiGet(
    urlConfig.busiURL + '/tax/order/detail?orderNo=' + orderNo
  ),
  createOrder: (data) => axios.apiPost(
    urlConfig.busiURL + '/tax/order/create', data
  ),
  checkOrderLimit: (params) => axios.apiGet(
    urlConfig.busiURL + '/tax/order/checkLimit', params, { 'No-Loading': 'True' }
  ),

  // ========== 服务费记录 ==========
  getServiceFeeList: (data) => axios.apiPost(
    urlConfig.busiURL + '/tax/order/service/fee/list', data
  ),
  retryServiceFee: (data) => axios.apiPost(
    urlConfig.busiURL + '/tax/service/fee/retry', data
  ),

  // ========== 分润记录 ==========
  getProfitShareList: (data) => axios.apiPost(
    urlConfig.busiURL + '/tax/order/profit/share/list', data
  ),
  retryProfitShare: (data) => axios.apiPost(
    urlConfig.busiURL + '/tax/profit/share/retry', data
  ),


};